import { Box, Typography } from "@mui/material";
import PageContentContainer from "../../components/shared/PageContentContainer";
import { ReactComponent as GreenBalootLogo } from "../../assets/icons/green-baloot-logo.svg";
import { useState } from "react";
import { AccountAPIs, BalootUserAPIs, BalootUserV2APIs } from "../../api/APIs";
import { useRequest } from "../../api/utils/useRequest";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsSynced } from "../../store/actions/AuthActions";
import { setConfig } from "../../store/actions/ConfigActions";
import PasswordTextField from "../../components/shared/PasswordTextField";
import { LoadingButton } from "@mui/lab";

function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const mobile = location.state?.mobile || "09102132022";
  const [password, setPassword] = useState("");
  const { loading: loginLoading, apiCall: login } = useRequest(
    AccountAPIs.login
  );

  const { loading: otpLoading, apiCall: sendForgotPasswordOTP } = useRequest(
    AccountAPIs.sendForgotPasswordOTP
  );
  const { loading: syncLoading, apiCall: sync } = useRequest(
    BalootUserV2APIs.sync
  );

  const sendOTP = () => {
    sendForgotPasswordOTP({
      data: { mobile },
      onSuccess: () => {
        navigate("../forgot-password/otp", { state: { mobile } });
      },
    });
  };

  const loginHandler = () => {
    login({
      data: { mobile: mobile, password: password },
      onSuccess: (response) => {
        localStorage.setItem("accessToken", response.access_token);
        localStorage.setItem("refreshToken", response.refresh_token);
        sync({
          onSuccess: (response) => {
            dispatch(setIsSynced(true));
            dispatch(setConfig({ config: response }));
            if (response.sejamInfo.status === "AUTHENTICATED") {
              navigate("/app", { replace: true });
            } else if (!response.personalInfo.nationalId) {
              navigate("/auth/national-id", { replace: true });
            } else if (
              !response.personalInfo.firstName &&
              !response.personalInfo.lastName
            ) {
              navigate("/auth/personal-info/first-name", { replace: true });
            } else {
              navigate("/app", { replace: true });
            }
          },
        });
      },
    });
  };

  return (
    <>
      <PageContentContainer
        sx={{
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          display: "block",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <GreenBalootLogo width={56} height={76} />
        </Box>
        <Typography
          variant="h5"
          color="grey.2"
          align="center"
          width={"100%"}
          mt={"24px"}
        >
          کلمه عبور خود را وارد کنید
        </Typography>
        <PasswordTextField password={password} setPassword={setPassword} />
        <Box width={"100%"}>
          <LoadingButton
            disabled={password.length < 8}
            loading={syncLoading || loginLoading}
            onClick={loginHandler}
            sx={{
              bgcolor: "primary.main",
              color: "common.white",
              mt: "16px",
              typography: "h5",
              fontSize: "14px",
            }}
            variant="contained"
            fullWidth
          >
            ورود
          </LoadingButton>
          <Box
            sx={{
              mt: "24px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <LoadingButton
              onClick={sendOTP}
              loading={otpLoading}
              sx={{ color: "grey.4" }}
              variant="text"
              size="small"
            >
              فراموشی رمز عبور
            </LoadingButton>
          </Box>
        </Box>
      </PageContentContainer>
    </>
  );
}

export default LoginPage;
